import React, { useState, useRef, useEffect } from "react";
import "./InputWithDropdown.scss";

const InputWithDropdown = ({ options, valueAndUnit, setValueAndUnit }) => {
  //   const [value, setValue] = useState("");
  //   const [unit, setUnit] = useState("₹");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  //   const options = ["₹", "%"];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="input-with-dropdown" ref={dropdownRef}>
      <input
        type="number"
        value={valueAndUnit?.value}
        onChange={(e) =>
          setValueAndUnit((prev) => ({
            ...prev,
            value: e.target.value,
          }))
        }
        placeholder="0"
      />
      <div className="dropdown">
        <button className="dropdown-toggle" onClick={() => setIsOpen(!isOpen)}>
          {valueAndUnit?.unit}
        </button>
        {isOpen && (
          <div className="dropdown-menu">
            {options.map((opt) => (
              <div
                key={opt}
                className={`dropdown-item ${opt === valueAndUnit?.unit ? "active" : ""}`}
                onClick={() => {
                  setValueAndUnit((prev) => ({
                    ...prev,
                    unit: opt,
                  }));
                  //   setUnit(opt);
                  setIsOpen(false);
                }}
              >
                {opt}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InputWithDropdown;
